<div class="topbar-item nav-user">
    <div ngbDropdown [placement]="'bottom-end'" class="dropdown">
        <button ngbDropdownToggle class="btn btn-link p-0 topbar-link dropdown-toggle drop-arrow-none px-2">
            <img src="assets/images/users/user-2.jpg" width="32" class="rounded-circle me-lg-2 d-flex"
                 alt="user-image">
            <div class="d-lg-flex align-items-center gap-1 d-none">
                <h5 class="my-0">
                  <span *ngIf="user">{{ user.persona.nombres }} {{user.persona.paterno}} {{user.persona.materno}}</span>
                </h5>
                <span class="d-flex align-middle"><ng-icon name="tablerChevronDown"/></span>
            </div>
        </button>
        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end">
            <div *ngFor="let item of menuItems">
                <div *ngIf="item.isHeader" class="dropdown-header noti-title">
                    <h6 class="text-overflow m-0">{{ item.label }}</h6>
                </div>

                <div *ngIf="item.isDivider" class="dropdown-divider"></div>

                <a *ngIf="!item.isHeader && !item.isDivider && item.url" [routerLink]="item.url" class="dropdown-item"
                   [ngClass]="item.class">
                    <ng-icon [name]="item.icon" size="17" class="align-middle d-inline-flex align-items-center me-2"/>
                    <span class="align-middle" [innerHTML]="item.label"></span>
                </a>

                <button *ngIf="!item.isHeader && !item.isDivider && item.action"
                        (click)="item.action()"
                        class="dropdown-item"
                        [ngClass]="item.class">
                  <ng-icon [name]="item.icon" size="17" class="align-middle d-inline-flex align-items-center me-2"/>
                  <span class="align-middle" [innerHTML]="item.label"></span>
                </button>
            </div>
        </div>

    </div>
</div>
